export default __webpack_public_path__ + "static/media/IMG_9650 copie.44c0d114.jpg";